//Margin conventions
var margin = {top: 10, right: 12, bottom: 30, left: 30};
var widther = d3.select(".gia-chart").node().clientWidth;
var width = widther - margin.left - margin.right,
    height = 350 - margin.top - margin.bottom;

//Parses date for correct time format
var parseDate = d3.timeParse("%b-%y"); 

//Appends the svg to the chart-container div
var svg = d3.select(".gia-chart").append("svg")
	.attr("width", width + margin.left + margin.right)
	.attr("height", height + margin.top + margin.bottom)
	.append("g")
	.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

//Creates the xScale 
	var xScale = d3.scaleBand()
		.rangeRound([0, width])
		.paddingInner(0.25);

	//Creates the yScale
	var yScale = d3.scaleLinear()
		.range([height, 0]);

	//Defines the y axis styles
	var yAxis = d3.axisLeft()
		.scale(yScale)
		.tickSize(-width)
		.tickPadding(8)
		.ticks(8);

	var zScale = d3.scaleOrdinal()
	    .range(["#005689", "#4bc6df"]);		

//Loads the data
d3.csv("data/casualties.csv", function(d, i, columns) {
	for (i = 1, t = 0; i < columns.length; ++i) t += d[columns[i]] = +d[columns[i]];
	d.total = t;
	return d;
},

function ready(err, data) {
	if (err) throw "error loading data";

	var keys = data.columns.slice(1);

	//FORMAT data
	data.forEach(function(d) {
    	d.date = parseDate(d.date);
	});

  	//Sets min and max on xScale
  	var xMin = d3.min(data, function(d) { return d.date;});
  	var xMax = d3.max(data, function(d) { return d.date;});
  	var totalMax = d3.max(data, function(d) { return d.total;});

  	//Sets scale domains
	xScale.domain(data.map(function(d) { return d.date; }));
	yScale.domain([0, totalMax]).nice();
	zScale.domain(keys);

	//Appends the y axis
	var yAxisGroup = svg.append("g")
		.attr("class", "y axis")
		.call(yAxis)
		.selectAll("g")
		.classed("g-baseline", function(d) { return d == 0 });

  	//Defines the x axis styles
  	var xAxis = d3.axisBottom()
    	.scale(xScale)
    	.tickPadding(8)
    	.tickSize(height)
    	.tickValues(xScale.domain().filter(function(d, i) { return !(i % 5); }))
    	.tickFormat(d3.timeFormat("%b %Y")) 
	
	//Binds the data to the bars      
	 svg.append("g")
	    .selectAll("g")
	    .data(d3.stack().keys(keys)(data))
	    .enter().append("g")
	    .attr("fill", function(d) { return zScale(d.key); })
	    .selectAll("rect")
	    .data(function(d) { return d; })
	    .enter().append("rect")
	    .attr("x", function(d) { return xScale(d.data.date); })
	    .attr("y", function(d) { return yScale(d[1]); })
	    .attr("height", function(d) { return yScale(d[0]) - yScale(d[1]); })
	    .attr("width", xScale.bandwidth())

	//Appends the x axis		
	var xAxisGroup = svg.append("g")
		.attr("class", "x axis")
		.call(xAxis);

	//RESPONSIVENESS
	d3.select(window).on("resize", resized);
	
	function resized() {

		//new margin
		var newMargin = {top: 10, right: 12, bottom: 40, left: 30};

		var newWidther = d3.select(".gia-chart").node().clientWidth;

		var newWidth = newWidther - newMargin.left - newMargin.right;

		//Change the width of the svg
		d3.select("svg")
			.attr("width", newWidth + newMargin.left + newMargin.right);

		//Change the xScale
		xScale
			.rangeRound([0, newWidth])

		//Update the bars
		d3.selectAll("rect")
		  .attr("x", function(d) { return xScale(d.data.date); })
		  .attr("width", xScale.bandwidth())

		//Updates xAxis
		d3.selectAll(".x.axis")
				.call(xAxis);   

		//Updates ticks
		xAxis
			.scale(xScale);

		//Updates yAxis  
		d3.selectAll(".y.axis")
				.call(yAxis); 

		yAxis
			.tickSize(-newWidth);
	};
})
